import * as React from 'react';
import { compose, setDisplayName, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { FadeScale } from 'ui/transitions';

import './CustomFileNameFormatLegend.css';

type OwnProps = {
    visible: boolean;
};

const legend = [
    [ '%rn', 'WC_REPORT_FORMAT_LEGEND_RN' ],
    [ '%rid', 'WC_REPORT_FORMAT_LEGEND_RID' ],
    [ '%YYYY', 'WC_REPORT_FORMAT_LEGEND_YYYY' ],
    [ '%MM', 'WC_REPORT_FORMAT_LEGEND_MM' ],
    [ '%DD', 'WC_REPORT_FORMAT_LEGEND_DD' ],
    [ '%HH', 'WC_REPORT_FORMAT_LEGEND_HH_24' ],
    [ '%hh', 'WC_REPORT_FORMAT_LEGEND_HH_12' ],
    [ '%ss', 'WC_REPORT_FORMAT_LEGEND_SS' ],
    [ '%fff', 'WC_REPORT_FORMAT_LEGEND_FFF' ],
    [ '%tt', 'WC_REPORT_FORMAT_LEGEND_TT' ],
];

const RawCustomFileNameFormatLegend = ({ visible, t, styles }: OwnProps & TranslateProps & OemProps) =>
    <FadeScale
        id="custom-file-name-format-legend-host"
        visible={ visible }
        duration={ 200 }
    >
        <div
            id="custom-file-name-format-connector"
            style={ styles.connector }
        />
        <div
            id="custom-file-name-format-legend"
            style={ styles.legend }
        >
            <table>
                <tbody>
                    { legend.map(([ variableName, textKey ]) =>
                        <tr key={ variableName }>
                            <th>{ variableName }</th>
                            <td>{ t(textKey) }</td>
                        </tr>
                    ) }
                </tbody>
            </table>
        </div>
    </FadeScale>
;

export const CustomFileNameFormatLegend = compose<OwnProps & TranslateProps & OemProps, OwnProps>(
    setDisplayName('CustomFileNameFormatLegend'),
    skin,
    withProps(({ styles }: OemProps) => ({
        styles: {
            ...styles,
            connector: {
                borderBottom: styles.Bordered.border,
            },
            legend: {
                ...styles.Workspace,
                ...styles.Bordered,
            },
        },
    })),
    translate(),
)(RawCustomFileNameFormatLegend);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/distribution/CustomFileNameFormatLegend.tsx